/* Akhletics PDP one-pager. Vanilla JS, scoped to one .akh-pdp section root. */
(function () {
  'use strict';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function ensureShakeKeyframes() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var existing = head ? head.querySelector('#akh-shake-style') : null;
    var style;

    if (existing) return;
    style = document.createElement('style');
    style.id = 'akh-shake-style';
    style.textContent = '@keyframes akh-shake{0%,100%{transform:translateX(0)}10%,30%,50%,70%,90%{transform:translateX(-5px)}20%,40%,60%,80%{transform:translateX(5px)}}';
    if (head) {
      head.appendChild(style);
    }
  }

  function hasAncestorClass(node, stopNode, className) {
    var n = node;
    while (n && n !== stopNode) {
      if (n.classList && n.classList.contains(className)) return true;
      n = n.parentNode;
    }
    return false;
  }

  function setButtonLabel(button, text) {
    var span;
    if (!button) return;
    span = button.querySelector('span');
    if (span) {
      span.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  function initRoot(root) {
    if (!root || !root.dataset) return;
    if (root.dataset.akhBound === '1') return;
    root.dataset.akhBound = '1';
    ensureShakeKeyframes();

    var variants = window.akhVariants || [];
    var optionNames = window.akhOptionNames || [];
    var colorImages = window.akhColorImages || {};
    var colorPos = optionNames.indexOf('Color') + 1;
    var sizePos = optionNames.indexOf('Size') + 1;
    var packPos = optionNames.indexOf('Pack') + 1;

    var mainImage = root.querySelector('#mainImage');
    var galleryMain = root.querySelector('.gallery-main');
    var prevBtn = root.querySelector('.gallery-nav.prev');
    var nextBtn = root.querySelector('.gallery-nav.next');
    var thumbs = toArray(root.querySelectorAll('.gallery-thumbs .thumb[data-image]'));
    var zoomOverlay = root.querySelector('#zoomOverlay');
    var zoomImage = root.querySelector('#zoomImage');
    var zoomClose = root.querySelector('.zoom-close');

    var pair1Swatches = toArray(root.querySelectorAll('.color-swatch:not(.p2)[data-color][data-image][data-zoom]'));
    var pair2Swatches = toArray(root.querySelectorAll('.color-swatch.p2[data-color2][data-image][data-zoom]'));
    var selectedColorText = root.querySelector('#selectedColor');
    var selectedColor2Text = root.querySelector('#selectedColor2');
    var colorLabelPrefix = root.querySelector('.color-label-prefix');

    var sizeBtns = toArray(root.querySelectorAll('.size-btn[data-size]'));
    var selectedSizeText = root.querySelector('#selectedSize');
    var sizeError = root.querySelector('#sizeError');
    var sizeOption = root.querySelector('#sizeOption');
    var sizeOptions = root.querySelector('.size-options');

    var bundleCards = toArray(root.querySelectorAll('.bundle-card[data-pack][data-price][data-compare][data-save]'));
    var pair2Color = root.querySelector('#pair2Color');
    var pair2Prop = root.querySelector('#akhPair2Prop');

    var priceCurrent = root.querySelector('.product-price .price-current');
    var priceOriginal = root.querySelector('.product-price .price-original');
    var priceBadge = root.querySelector('.product-price .price-badge');
    var stickyPriceCurrent = root.querySelector('.sticky-price-current');
    var stickyPriceOriginal = root.querySelector('.sticky-price-original');
    var stickyBuyBtn = root.querySelector('#stickyBuyBtn');
    var stickyCart = root.querySelector('#stickyCart');

    var form = root.querySelector('#akh-product-form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addToCart = root.querySelector('#addToCart');

    var cartOverlay = root.querySelector('#cartOverlay');
    var cartDrawer = root.querySelector('#cartDrawer');
    var cartItems = root.querySelector('#cartItems');
    var cartEmpty = root.querySelector('#cartEmpty');
    var cartFoot = root.querySelector('#cartFoot');
    var cartSavingsRow = root.querySelector('#cartSavingsRow');
    var cartSavings = root.querySelector('#cartSavings');
    var cartSubtotal = root.querySelector('#cartSubtotal');
    var cartTotal = root.querySelector('#cartTotal');
    var cartDrawerCount = root.querySelector('#cartDrawerCount');
    var cartClose = root.querySelector('#cartClose');
    var cartContinue = root.querySelector('#cartContinue');
    var cartCheckout = root.querySelector('#cartCheckout');

    var tabBtns = toArray(root.querySelectorAll('.tab-btn[data-tab]'));
    var tabPanels = toArray(root.querySelectorAll('.tab-panel'));
    var openSizeGuide = root.querySelector('#openSizeGuide');
    var tabsSection = root.querySelector('.tabs-section');
    var sizeGuideModal = root.querySelector('#sizeGuideModal');
    var modalClose = sizeGuideModal ? sizeGuideModal.querySelector('.modal-close') : null;
    var policyModal = root.querySelector('#policyModal');
    var policyClose = policyModal ? policyModal.querySelector('.modal-close') : null;

    var bandCta = root.querySelector('#bandCta');
    var bandCards = toArray(root.querySelectorAll('.band-color-card[data-bandcolor]'));
    var productGrid = root.querySelector('.akh-product-grid');

    var state = { color: null, size: null, pack: null };
    var images = [];
    var currentImageIndex = 0;
    var displayedColor = null;
    var pair2Touched = false;
    var colorCycle = [];
    var stickyTick = false;
    var cartOpener = null;
    var cartHideTimer = null;
    // Optimistische Cart-Schicht: UI rendert sofort aus lastCart,
    // Server-Calls laufen serialisiert im Hintergrund und heilen bei Fehlern.
    var lastCart = null;
    var pendingOps = 0;
    var opChain = Promise.resolve();
    var qtyTimers = {};
    var qtyTargets = {};
    var qtyPending = {};
    var localKeySeq = 0;
    // Composite-Ops (Upsell/Merge) laufen exklusiv: ein Lock gegen
    // Doppelklick und überlappende Plan-Ausführung.
    var compositeBusy = false;
    // Einmalige Fehlermeldung im Drawer nach fehlgeschlagener Server-Op.
    var cartNoticeText = '';
    // Request-Generation: jede Mutation/jeder neuere Reload entwertet
    // in-flight Reload-Antworten — eine verspätete Vor-Merge-Antwort darf
    // den frischeren Stand nie überschreiben.
    var cartGen = 0;
    // Jüngste autoritative Server-Antwort, deren Render aufgeschoben wurde
    // (pendingOps > 0 beim Eintreffen) — wird beim Erreichen von 0 gerendert.
    var deferredCart = null;
    // Sync-Fehlerzustand: gesetzt wenn auch die Recovery scheitert; blockt
    // den Checkout bis eine Reconciliation gelungen ist.
    var cartSyncFailed = false;

    function variantOption(variant, pos) {
      if (pos === 1) return variant.option1;
      if (pos === 2) return variant.option2;
      if (pos === 3) return variant.option3;
      return null;
    }

    function readImagesFromThumbs() {
      images = [];
      thumbs.forEach(function (thumb) {
        images.push(thumb.dataset.image);
      });
      if (images.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      } else {
        if (prevBtn) prevBtn.style.display = '';
        if (nextBtn) nextBtn.style.display = '';
      }
    }

    function activateGalleryImage(index) {
      if (!images.length) return;
      currentImageIndex = (index + images.length) % images.length;
      if (mainImage) {
        mainImage.src = images[currentImageIndex];
      }
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('active', i === currentImageIndex);
      });
    }

    function imageSetForColor(color) {
      if (colorImages[color]) return colorImages[color];
      if (pair1Swatches.length && colorImages[pair1Swatches[0].dataset.color]) {
        return colorImages[pair1Swatches[0].dataset.color];
      }
      return null;
    }

    function setGalleryColor(color) {
      var imgs = imageSetForColor(color);
      var firstThumb;
      var thumbImg;

      if (!imgs || !mainImage) return;
      displayedColor = color;
      mainImage.src = imgs.img;
      mainImage.srcset = imgs.img + ' 1000w, ' + imgs.zoom + ' 1600w';
      firstThumb = thumbs[0];
      if (firstThumb) {
        firstThumb.dataset.image = imgs.img;
        thumbImg = firstThumb.querySelector('img');
        if (thumbImg) thumbImg.src = imgs.img;
      }
      readImagesFromThumbs();
      activateGalleryImage(0);
    }

    function currentPair1Color() {
      var i;
      for (i = 0; i < pair1Swatches.length; i += 1) {
        if (pair1Swatches[i].classList.contains('active')) return pair1Swatches[i].dataset.color;
      }
      if (state.color) return state.color;
      return colorCycle.length ? colorCycle[0] : null;
    }

    function currentPair2Color() {
      var i;
      for (i = 0; i < pair2Swatches.length; i += 1) {
        if (pair2Swatches[i].classList.contains('active')) return pair2Swatches[i].dataset.color2;
      }
      return selectedColor2Text ? selectedColor2Text.textContent : '';
    }

    function isMultiPackActive() {
      return packPos > 0 && parseInt(state.pack, 10) >= 2;
    }

    function nextColor(color) {
      var idx;
      if (!colorCycle.length) return color;
      idx = colorCycle.indexOf(color);
      if (idx === -1) return colorCycle[0];
      return colorCycle[(idx + 1) % colorCycle.length];
    }

    // ---- Bestands-Gate: Solo-Varianten sind die einzige Bestandswahrheit.
    // Ein 2er-Pack verspricht ZWEI physische Solo-Einheiten — jede Pack-/
    // Pair-2-Wahl fragt deshalb die Solo-Verfügbarkeit (und beim Same-Color-
    // Pack die Solo-MENGE aus window.akhSoloQty, Liquid-generiert).

    function soloVariantFor(color, size) {
      var i;
      var variant;
      for (i = 0; i < variants.length; i += 1) {
        variant = variants[i];
        if (colorPos > 0 && variantOption(variant, colorPos) !== color) continue;
        if (sizePos > 0 && variantOption(variant, sizePos) !== size) continue;
        if (packPos > 0 && parseInt(variantOption(variant, packPos), 10) >= 2) continue;
        return variant;
      }
      return null;
    }

    function soloAvailable(color, size) {
      var variant = soloVariantFor(color, size);
      return !!(variant && variant.available);
    }

    function soloQty(color, size) {
      var map = window.akhSoloQty || {};
      var qty = map[color + '~' + size];
      // Map fehlt (alter Cache) oder -1 (untracked/continue): nicht härter
      // gaten als das available-Flag es tut.
      if (typeof qty !== 'number') return -1;
      return qty;
    }

    function pair2Allowed(pair1Color, pair2Color, size) {
      var qty;
      if (!size) return true;
      if (!soloAvailable(pair2Color, size)) return false;
      if (pair2Color === pair1Color) {
        qty = soloQty(pair2Color, size);
        if (qty >= 0 && qty < 2) return false;
      }
      return true;
    }

    // Erste erlaubte Pair-2-Farbe in nextColor-Reihenfolge (inkl. Pair-1-
    // Farbe selbst als letzte Option, wenn genug Stück da sind).
    function firstAllowedPair2(pair1Color, size) {
      var start = colorCycle.indexOf(pair1Color);
      var candidate;
      var i;
      if (!colorCycle.length) return null;
      for (i = 1; i <= colorCycle.length; i += 1) {
        candidate = colorCycle[((start + i) % colorCycle.length + colorCycle.length) % colorCycle.length];
        if (pair2Allowed(pair1Color, candidate, size)) return candidate;
      }
      return null;
    }

    function defaultPair2(pair1Color) {
      if (!state.size) return nextColor(pair1Color);
      return firstAllowedPair2(pair1Color, state.size) || '';
    }

    function applyPair2Availability() {
      var pair1 = currentPair1Color();
      var size = state.size;
      var current;
      var replacement;
      var anyAllowed = false;

      if (!pair2Swatches.length) return;
      pair2Swatches.forEach(function (swatch) {
        var allowed = pair2Allowed(pair1, swatch.dataset.color2, size);
        swatch.dataset.akhDisabled = allowed ? '' : '1';
        swatch.setAttribute('aria-disabled', allowed ? 'false' : 'true');
        swatch.style.opacity = allowed ? '' : '0.3';
        swatch.style.cursor = allowed ? '' : 'not-allowed';
        if (allowed) anyAllowed = true;
      });
      bundleCards.forEach(function (card) {
        var isMulti = parseInt(card.dataset.pack, 10) >= 2;
        var cardAllowed;
        if (!isMulti) return;
        cardAllowed = !size || (anyAllowed && soloAvailable(pair1, size));
        card.dataset.akhDisabled = cardAllowed ? '' : '1';
        card.setAttribute('aria-disabled', cardAllowed ? 'false' : 'true');
        card.style.opacity = cardAllowed ? '' : '0.4';
        card.style.cursor = cardAllowed ? '' : 'not-allowed';
      });
      // Liegt die aktuelle Auswahl auf einer gesperrten Farbe, sichtbar auf
      // die erste erlaubte schieben — nie still eine gesperrte verkaufen.
      current = currentPair2Color();
      if (size && current && !pair2Allowed(pair1, current, size)) {
        replacement = firstAllowedPair2(pair1, size);
        applyPair2Color(replacement || '');
      }
    }

    function applyPair2Color(color) {
      pair2Swatches.forEach(function (swatch) {
        swatch.classList.toggle('active', swatch.dataset.color2 === color);
      });
      if (selectedColor2Text) selectedColor2Text.textContent = color || '';
      if (isMultiPackActive() && pair2Prop) pair2Prop.value = color || '';
    }

    function refreshPair2Default() {
      if (pair2Touched) return;
      applyPair2Color(defaultPair2(currentPair1Color()));
    }

    function updatePair2Prop() {
      if (!pair2Prop) return;
      if (isMultiPackActive()) {
        pair2Prop.disabled = false;
        pair2Prop.value = currentPair2Color() || defaultPair2(currentPair1Color()) || '';
      } else {
        pair2Prop.disabled = true;
        pair2Prop.value = '';
      }
    }

    function findVariant() {
      var i;
      var variant;
      var colorOk;
      var sizeOk;
      var packOk;

      for (i = 0; i < variants.length; i += 1) {
        variant = variants[i];
        colorOk = colorPos === 0 || variantOption(variant, colorPos) === state.color;
        sizeOk = sizePos === 0 || variantOption(variant, sizePos) === state.size;
        packOk = packPos === 0 || variantOption(variant, packPos) === state.pack;
        if (colorOk && sizeOk && packOk) return variant;
      }
      return null;
    }

    function isSizeSelected() {
      return sizePos === 0 || !!state.size;
    }

    function syncStickyBtnText() {
      if (!stickyBuyBtn) return;
      stickyBuyBtn.textContent = isSizeSelected() ? 'Add to Cart' : 'Select Size';
    }

    function updateVariant() {
      var variant = findVariant();
      var sizeChosen = isSizeSelected();

      if (variant && idInput) idInput.value = variant.id;
      if (!addToCart) {
        syncStickyBtnText();
        return;
      }
      if (sizeChosen && (!variant || !variant.available)) {
        addToCart.disabled = true;
        setButtonLabel(addToCart, 'Sold Out');
      } else {
        addToCart.disabled = false;
        setButtonLabel(addToCart, 'Add to Cart');
      }
      syncStickyBtnText();
    }

    function applyPackCard(card) {
      var compare;
      var save;
      var multi;

      if (!card) {
        updatePair2Prop();
        return;
      }
      compare = card.dataset.compare || '';
      save = card.dataset.save || '';
      multi = parseInt(card.dataset.pack, 10) >= 2;

      if (priceCurrent) priceCurrent.textContent = card.dataset.price || '';
      if (priceOriginal) {
        priceOriginal.textContent = compare;
        priceOriginal.style.display = compare ? '' : 'none';
      }
      if (priceBadge) {
        priceBadge.textContent = save ? 'SAVE ' + save : '';
        priceBadge.style.display = save ? '' : 'none';
      }
      if (stickyPriceCurrent) stickyPriceCurrent.textContent = card.dataset.price || '';
      if (stickyPriceOriginal) {
        stickyPriceOriginal.textContent = compare;
        stickyPriceOriginal.style.display = compare ? '' : 'none';
      }

      if (multi) {
        if (pair2Color) pair2Color.hidden = false;
        if (colorLabelPrefix) colorLabelPrefix.textContent = 'Color · Pair 1:';
        refreshPair2Default();
      } else {
        if (pair2Color) pair2Color.hidden = true;
        if (colorLabelPrefix) colorLabelPrefix.textContent = 'Color:';
        setGalleryColor(currentPair1Color());
      }
      updatePair2Prop();
    }

    function activateTab(name) {
      tabBtns.forEach(function (button) {
        var on = button.dataset.tab === name;
        button.classList.toggle('active', on);
        button.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      tabPanels.forEach(function (panel) {
        var on = panel.id === 'tab-' + name;
        panel.classList.toggle('active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    function closeSizeGuideModal() {
      if (!sizeGuideModal) return;
      sizeGuideModal.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Policy-Popup: per Footer-Link oder Deep-Link (#policy, #policy-privacy,
    // #policy-terms, #policy-shipping, #policy-returns) erreichbar — die
    // Policies leben als Modal auf der einen Produktseite, ohne Unterseiten.
    function openPolicyModal(hash) {
      var target;
      var body;
      if (!policyModal) return;
      policyModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (hash && hash !== '#policy') {
        target = policyModal.querySelector(hash);
        if (target && typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({ block: 'start' });
        }
      } else {
        body = policyModal.querySelector('.policy-body');
        if (body) body.scrollTop = 0;
      }
      if (policyClose && typeof policyClose.focus === 'function') {
        policyClose.focus({ preventScroll: true });
      }
    }

    function closePolicyModal() {
      if (!policyModal) return;
      policyModal.classList.remove('active');
      document.body.style.overflow = '';
      // Hash aufräumen, damit Reload/Back nicht wieder ins Modal springt
      if (window.location.hash.indexOf('#policy') === 0 && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    function isPolicyHash(hash) {
      return typeof hash === 'string' && hash.indexOf('#policy') === 0;
    }

    function showMissingSizeFromForm() {
      if (sizeError) sizeError.hidden = false;
      if (sizeOptions) {
        sizeOptions.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeOptions.style.animation = 'akh-shake .5s';
        setTimeout(function () {
          sizeOptions.style.animation = '';
        }, 500);
      }
    }

    function showMissingSizeFromSticky() {
      if (sizeError) sizeError.hidden = false;
      if (sizeOption) {
        sizeOption.scrollIntoView({ behavior: 'smooth', block: 'start' });
        sizeOption.classList.remove('size-attention');
        void sizeOption.offsetWidth;
        sizeOption.classList.add('size-attention');
        setTimeout(function () {
          sizeOption.classList.remove('size-attention');
        }, 1200);
      }
    }

    function updateStickyReveal() {
      stickyTick = false;
      if (!stickyCart || !addToCart) return;
      stickyCart.classList.toggle('visible', addToCart.getBoundingClientRect().bottom < 0);
    }

    function queueStickyReveal() {
      if (stickyTick) return;
      stickyTick = true;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(updateStickyReveal);
      } else {
        setTimeout(updateStickyReveal, 16);
      }
    }

    function scrollToBuyBox() {
      if (productGrid) productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function esc(value) {
      return String(value || '').replace(/[&<>"]/g, function (char) {
        if (char === '&') return '&amp;';
        if (char === '<') return '&lt;';
        if (char === '>') return '&gt;';
        if (char === '"') return '&quot;';
        return char;
      });
    }

    function isBadNumber(value) {
      return Number.isNaN ? Number.isNaN(value) : isNaN(value);
    }

    function formatWithSeparators(value, decimals, thousands, decimal) {
      var fixed = value.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      if (decimals === 0) return parts[0];
      return parts[0] + decimal + parts[1];
    }

    function formatMoney(cents) {
      var format = window.akhMoneyFormat || '${{amount}}';
      var value = parseInt(cents, 10);
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : 'amount';
      var amount;

      if (isBadNumber(value)) value = 0;
      value = value / 100;

      if (placeholder === 'amount_no_decimals') {
        amount = formatWithSeparators(value, 0, ',', '.');
      } else if (placeholder === 'amount_with_comma_separator') {
        amount = formatWithSeparators(value, 2, '.', ',');
      } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
        amount = formatWithSeparators(value, 0, '.', ',');
      } else if (placeholder === 'amount_with_apostrophe_separator') {
        amount = formatWithSeparators(value, 2, "'", '.');
      } else if (placeholder === 'amount_with_space_separator') {
        amount = formatWithSeparators(value, 2, ' ', '.');
      } else {
        amount = formatWithSeparators(value, 2, ',', '.');
      }
      return format.replace(match ? match[0] : '{{amount}}', amount);
    }

    function cdnImg(url, width) {
      if (!url) return '';
      return String(url) + (String(url).indexOf('?') === -1 ? '?width=' : '&width=') + width;
    }

    // Fetch mit hartem Zeitdeckel: eine nie settelnde Cart-Anfrage darf
    // pendingOps nicht ewig offen halten (Checkout wäre sonst dauerhaft
    // blockiert). Die verspätete Antwort läuft ins Leere; Recovery holt
    // danach die Server-Wahrheit.
    function fetchWithTimeout(url, opts) {
      var ms = window.__akhFetchTimeoutMs || 10000;
      return Promise.race([
        fetch(url, opts),
        new Promise(function (ignore, reject) {
          setTimeout(function () {
            reject(new Error('Cart request timed out'));
          }, ms);
        })
      ]);
    }

    function responseJson(response) {
      if (!response || !response.ok) {
        // Shopify-422-Bodies tragen die echte Ursache (z.B. sold out) —
        // Message erhalten, damit der Drawer sie anzeigen kann.
        if (response && typeof response.json === 'function') {
          return response.json().then(function (data) {
            // description trägt bei Shopify die konkrete Ursache
            // ("... sold out"), message oft nur generisches "Cart Error".
            var msg = data && (data.description || data.message);
            throw new Error(msg ? String(msg) : 'Cart request failed');
          }, function () {
            throw new Error('Cart request failed');
          });
        }
        throw new Error('Cart request failed');
      }
      return response.json();
    }

    function updateBadge(count) {
      var link = document.getElementById('cart-icon-bubble');
      var badge;
      var span;
      var akhCounts = document.querySelectorAll('.akh-header .akh-hdr-count');
      var k;

      for (k = 0; k < akhCounts.length; k += 1) {
        akhCounts[k].textContent = count;
      }
      if (!link) return;
      badge = link.querySelector('.cart-count-bubble');
      span = badge ? badge.querySelector('span[aria-hidden="true"]') : null;

      if (count === 0) {
        if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
        return;
      }
      if (span) {
        span.textContent = count;
        return;
      }
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'cart-count-bubble';
        link.appendChild(badge);
      }
      span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = count;
      badge.appendChild(span);
    }

    function find2PackVariant(color, size) {
      var i;
      var variant;

      if (packPos <= 0) return null;
      for (i = 0; i < variants.length; i += 1) {
        variant = variants[i];
        if (variantOption(variant, colorPos) === color &&
            variantOption(variant, sizePos) === size &&
            parseInt(variantOption(variant, packPos), 10) >= 2 &&
            variant.available) {
          return variant;
        }
      }
      return null;
    }

    function swatchHex(color) {
      var i;
      for (i = 0; i < pair1Swatches.length; i += 1) {
        if (pair1Swatches[i].dataset.color === color) {
          return pair1Swatches[i].style.backgroundColor || '#333';
        }
      }
      return '#333';
    }

    function itemOptions(item) {
      var out = { color: '', size: '', pack: '' };
      (item.options_with_values || []).forEach(function (option) {
        if (!option) return;
        if (option.name === 'Color') out.color = option.value || '';
        if (option.name === 'Size') out.size = option.value || '';
        if (option.name === 'Pack') out.pack = option.value || '';
      });
      return out;
    }

    function isPackItem(item) {
      if (item.properties && item.properties['Pair 2 color']) return true;
      var pack = itemOptions(item).pack;
      return !!pack && parseInt(pack, 10) >= 2;
    }

    // Zwei Solo-Paare gleicher Größe (auch qty 2 einer Zeile) lassen sich in
    // die 2-Pair-Pack-Variante zusammenlegen. Liefert je Größe einen Plan
    // oder nichts — nicht bei aktiven Zeilen-Rabatten (Deal wäre doppelt)
    // und nicht ohne verfügbare Pack-Variante.
    function buildMergePlans(cart) {
      var groups = {};
      var plans = {};

      (cart && cart.items ? cart.items : []).forEach(function (item) {
        var opts;
        var group;
        var unitPrice;

        if (isPackItem(item)) return;
        opts = itemOptions(item);
        if (!opts.size) return;
        group = groups[opts.size] || (groups[opts.size] = { lines: [], total: 0, discounted: false });
        unitPrice = parseInt(item.final_price, 10);
        if (isBadNumber(unitPrice)) unitPrice = parseInt(item.price, 10);
        if (isBadNumber(unitPrice)) unitPrice = 0;
        if (parseInt(item.final_price, 10) !== parseInt(item.price, 10)) group.discounted = true;
        group.lines.push({ key: item.key, color: opts.color, lineQty: item.quantity, price: unitPrice });
        group.total += item.quantity;
      });

      Object.keys(groups).forEach(function (size) {
        var group = groups[size];
        var u1 = null;
        var u2 = null;
        var target = null;
        var soloPrice;
        var candidate;
        var i;
        var j;

        if (group.discounted || group.total < 2) return;
        // Zeilen-aggregiert (kein Einheiten-Cap): erste Zeile mit VERFÜGBARER
        // Pack-Variante wird Pair 1 — Teil-Ausverkauf (Black/Navy-Pack weg,
        // Khaki-Pack da) findet so immer noch ein Paar. Pair 2 kommt aus
        // derselben Zeile (wenn qty>=2), sonst aus der ersten anderen Zeile.
        for (i = 0; i < group.lines.length && !target; i += 1) {
          candidate = find2PackVariant(group.lines[i].color, size);
          if (!candidate) continue;
          if (group.lines[i].lineQty >= 2) {
            u1 = group.lines[i];
            u2 = group.lines[i];
            target = candidate;
            break;
          }
          for (j = 0; j < group.lines.length; j += 1) {
            if (j === i) continue;
            u1 = group.lines[i];
            u2 = group.lines[j];
            target = candidate;
            break;
          }
        }
        if (!target) return;
        soloPrice = u1.price + u2.price;
        if (soloPrice - parseInt(target.price, 10) <= 0) return;
        plans[size] = {
          size: size,
          key1: u1.key,
          key2: u2.key,
          lineQty1: u1.lineQty,
          lineQty2: u2.lineQty,
          color1: u1.color,
          color2: u2.color,
          target: target,
          soloPrice: soloPrice,
          packPrice: parseInt(target.price, 10),
          save: soloPrice - parseInt(target.price, 10)
        };
      });

      return plans;
    }

    function setCartLoading(on) {
      if (cartDrawer) cartDrawer.classList.toggle('akh-loading', !!on);
    }

    function renderCart(cart) {
      var html = '';
      var totalSaveCents = 0;

      setCartLoading(false);
      cart = cart || {};
      lastCart = cart;
      updateBadge(cart.item_count || 0);
      if (cartDrawerCount) cartDrawerCount.textContent = '(' + (cart.item_count || 0) + ')';

      if (!cart.items || cart.items.length === 0) {
        if (cartItems) {
          cartItems.hidden = true;
          cartItems.innerHTML = '';
        }
        if (cartFoot) cartFoot.hidden = true;
        if (cartEmpty) cartEmpty.classList.add('show');
        return;
      }

      if (cartEmpty) cartEmpty.classList.remove('show');
      if (cartItems) cartItems.hidden = false;
      if (cartFoot) cartFoot.hidden = false;

      // Einmalige Fehlermeldung (z.B. sold out) — wird nach dem Rendern
      // verworfen, der nächste Render ist wieder sauber.
      if (cartNoticeText) {
        html += '<div class="akh-cart-notice" style="border:1px solid #d97706;color:#92400e;background:rgba(217,119,6,.08);border-radius:8px;padding:8px 10px;margin:0 0 12px;font-size:13px;">' + esc(cartNoticeText) + '</div>';
        cartNoticeText = '';
      }

      // Merge-Banner: 2 Solo-Paare gleicher Größe → ein Klick macht daraus
      // den 2-Pair-Deal. Ersetzt für diese Zeilen den Einzel-Upsell.
      var mergePlans = buildMergePlans(cart);
      Object.keys(mergePlans).forEach(function (size) {
        var plan = mergePlans[size];
        html += '<div class="akh-cart-merge" style="border:2px solid #16a34a;border-radius:10px;padding:12px 14px;margin:0 0 14px;background:rgba(22,163,74,.06);">' +
          '<p style="margin:0 0 4px;font-weight:700;font-size:14px;color:#16a34a;">2-Pair Deal available</p>' +
          '<p style="margin:0 0 10px;font-size:13px;line-height:1.45;">You have 2 pairs in Size ' + esc(plan.size) + ' (' + esc(plan.color1) + ' + ' + esc(plan.color2) + '). Combine them into the 2-Pair Pack: ' + formatMoney(plan.packPrice) + ' instead of ' + formatMoney(plan.soloPrice) + '.</p>' +
          '<button class="akh-cart-merge-btn" type="button" data-size="' + esc(plan.size) + '" style="display:block;width:100%;border:0;border-radius:8px;padding:10px 12px;background:#16a34a;color:#fff;font-weight:700;font-size:14px;cursor:pointer;">Apply deal &middot; Save ' + formatMoney(plan.save) + '</button>' +
        '</div>';
      });

      cart.items.forEach(function (item, i) {
        var line = i + 1;
        var color = '';
        var size = '';
        var pair2 = item.properties && item.properties['Pair 2 color'];
        var options = item.options_with_values || [];
        var variantHtml;
        var upsellHtml = '';
        var pickerHtml = '';
        var thumb;
        var target;

        options.forEach(function (option) {
          if (!option) return;
          if (option.name === 'Color') color = option.value || '';
          if (option.name === 'Size') size = option.value || '';
        });

        if (isPackItem(item)) {
          variantHtml = '<p class="akh-cart-item-variant">2-Pair Pack' + (size ? ' &middot; Size ' + esc(size) : '') + '</p>' +
            (pair2 ? '<p class="akh-cart-item-variant">Pair 1 ' + esc(color) + ' &middot; Pair 2 ' + esc(pair2) + '</p>' : '');
        } else {
          target = find2PackVariant(color, size);
          // Upsell nur anbieten, wenn mindestens eine Zweitfarbe lieferbar ist
          if (target && !mergePlans[size] && firstAllowedPair2(color, size)) {
            if (colorCycle.length) {
              colorCycle.forEach(function (c) {
                // Bestands-Gate: nicht lieferbare Zweitfarben sind sichtbar
                // gesperrt und tragen keine Klick-Attribute
                if (!pair2Allowed(color, c, size)) {
                  pickerHtml += '<span class="akh-cart-pick-swatch-off" aria-disabled="true" title="' + esc(c) + ' — out of stock" style="width:30px;height:30px;border-radius:50%;border:2px solid #e5e7eb;opacity:.3;background-color:' + swatchHex(c) + ';"></span>';
                  return;
                }
                pickerHtml += '<button class="akh-cart-pick-swatch" type="button" data-line="' + line + '" data-index="' + i + '" data-key="' + esc(item.key) + '" data-color="' + esc(color) + '" data-size="' + esc(size) + '" data-qty="' + esc(item.quantity) + '" data-color2="' + esc(c) + '" aria-label="' + esc(c) + '" title="' + esc(c) + '" style="width:30px;height:30px;border-radius:50%;border:2px solid #d1d5db;cursor:pointer;background-color:' + swatchHex(c) + ';"></button>';
              });
              pickerHtml = '<div class="akh-cart-upsell-pick" hidden style="margin:8px 0 2px;">' +
                '<p style="margin:0 0 6px;font-size:12px;font-weight:600;">Color for your 2nd pair:</p>' +
                '<div style="display:flex;gap:8px;">' + pickerHtml + '</div>' +
              '</div>';
            }
            upsellHtml = '<button class="akh-cart-upsell-btn" type="button" data-line="' + line + '" data-index="' + i + '" data-key="' + esc(item.key) + '" data-color="' + esc(color) + '" data-size="' + esc(size) + '" data-qty="' + esc(item.quantity) + '">Make it 2 pairs · save 109 AED</button>' + pickerHtml;
          }
          variantHtml = '<p class="akh-cart-item-variant">' + esc(color) + (size ? ' &middot; Size ' + esc(size) : '') + '</p>';
        }

        thumb = cdnImg(item.image, 200);
        if (!thumb && colorImages[color] && colorImages[color].img) thumb = colorImages[color].img;

        // Compare-at der Variante: liefert den durchgestrichenen Alt-Preis
        // der Zeile (z.B. 358 beim 2-Pack) und füttert die You-save-Summe.
        var lineCompareHtml = '';
        variants.forEach(function (variant) {
          var variantId = item.variant_id || item.id;
          var compare;
          var price;

          if (variant.id !== variantId) return;
          compare = parseInt(variant.compare_at_price, 10);
          price = parseInt(variant.price, 10);
          if (!isBadNumber(compare) && !isBadNumber(price) && compare > price) {
            totalSaveCents += (compare - price) * item.quantity;
            lineCompareHtml = '<s class="akh-cart-item-compare" style="display:block;color:#dc2626;font-size:12px;font-weight:400;text-decoration:line-through;">' + formatMoney(compare * item.quantity) + '</s>';
          }
        });

        html += '<div class="akh-cart-item">' +
          '<img class="akh-cart-item-thumb" src="' + esc(thumb) + '" alt="Modest Swim Shorts" width="64" height="86">' +
          '<div class="akh-cart-item-body">' +
            '<div class="akh-cart-item-head">' +
              '<div>' +
                '<p class="akh-cart-item-title">Modest Swim Shorts</p>' +
                variantHtml +
              '</div>' +
              '<span class="akh-cart-item-price">' + formatMoney(item.final_line_price) + lineCompareHtml + '</span>' +
            '</div>' +
            upsellHtml +
            '<div class="akh-cart-item-actions">' +
              '<div class="akh-cart-qty" aria-label="Quantity">' +
                '<button class="akh-cart-qty-btn" type="button" data-line="' + line + '" data-key="' + esc(item.key) + '" data-delta="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span class="akh-cart-qty-num">' + esc(item.quantity) + '</span>' +
                '<button class="akh-cart-qty-btn" type="button" data-line="' + line + '" data-key="' + esc(item.key) + '" data-delta="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="akh-cart-item-remove" type="button" data-line="' + line + '" data-key="' + esc(item.key) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      });

      if (cartItems) cartItems.innerHTML = html;
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
      if (cartSavings) cartSavings.textContent = formatMoney(totalSaveCents);
      if (cartSavingsRow) cartSavingsRow.hidden = totalSaveCents <= 0;
    }

    function reloadCart() {
      var gen = ++cartGen;
      return fetchWithTimeout('/cart.js', { credentials: 'same-origin' })
        .then(responseJson)
        .then(function (cart) {
          // Nur einliefern, wenn keine neuere Mutation dazwischenkam —
          // sonst stampft eine stale Antwort den frischeren Stand platt
          // (Race: Open-Reload vs. Merge).
          if (gen === cartGen) settleRender(cart);
          return cart;
        })
        .catch(function () {
          return null;
        });
    }

    function cloneCart(cart) {
      try {
        return JSON.parse(JSON.stringify(cart));
      } catch (e) {
        return null;
      }
    }

    function localCartCopy() {
      var copy = lastCart && lastCart.items ? cloneCart(lastCart) : null;
      return copy || { items: [], item_count: 0, total_price: 0 };
    }

    function recomputeCart(cart) {
      var count = 0;
      var total = 0;

      cart.items.forEach(function (item) {
        var unit = parseInt(item.final_price, 10);
        if (isBadNumber(unit)) unit = parseInt(item.price, 10);
        if (isBadNumber(unit)) unit = 0;
        item.final_line_price = unit * item.quantity;
        item.line_price = item.final_line_price;
        count += item.quantity;
        total += item.final_line_price;
      });
      cart.item_count = count;
      cart.total_price = total;
      return cart;
    }

    // Serialisierte Hintergrund-Ops: fn liefert ein Promise. Antworten kommen
    // durch die Kette IN REIHENFOLGE — gerendert wird nur, wenn danach nichts
    // mehr aussteht (auch kein Debounce-Timer): die letzte Antwort ist die
    // Server-Wahrheit, alles davor würde den optimistischen Stand zurückdrehen.
    // Autoritative Server-Antwort einliefern: rendert sofort wenn nichts
    // mehr aussteht, sonst wird sie aufgeschoben und beim letzten
    // Op-Abschluss gerendert — so verwirft ein Überlapp aus Mutation und
    // Recovery nie ALLE Antworten (Drawer bliebe sonst stale).
    function settleRender(cart) {
      if (cart && cart.items) {
        deferredCart = cart;
        cartSyncFailed = false;
      }
      if (pendingOps === 0 && deferredCart) {
        var toRender = deferredCart;
        deferredCart = null;
        renderCart(toRender);
      }
    }

    function queueOp(fn) {
      pendingOps += 1;
      opChain = opChain.then(function () {
        return fn();
      }).then(function (cart) {
        pendingOps = Math.max(0, pendingOps - 1);
        cartGen += 1;
        settleRender(cart);
      }, function (error) {
        pendingOps = Math.max(0, pendingOps - 1);
        cartNoticeText = error && error.message && error.message !== 'Cart request failed'
          ? error.message
          : 'Something went wrong — your cart was refreshed.';
        recoverReload();
      });
    }

    // Recovery nach Server-Fehler MUSS als pendende Op zählen: sonst sieht
    // der Checkout pendingOps 0, navigiert und der Drawer zeigt noch den
    // optimistischen Stand statt der Server-Wahrheit. Scheitert auch die
    // Recovery, wird der Fehlerzustand sichtbar gemacht und der Checkout
    // bleibt bis zur gelungenen Reconciliation gesperrt.
    function recoverReload() {
      var gen = ++cartGen;
      pendingOps += 1;
      return fetchWithTimeout('/cart.js', { credentials: 'same-origin' })
        .then(responseJson)
        .then(function (cart) {
          pendingOps = Math.max(0, pendingOps - 1);
          if (gen === cartGen) {
            settleRender(cart);
          } else if (pendingOps === 0) {
            settleRender(null);
          }
        }, function () {
          pendingOps = Math.max(0, pendingOps - 1);
          cartSyncFailed = true;
          if (!cartNoticeText) cartNoticeText = 'Connection issue — please try again.';
          if (pendingOps === 0 && lastCart && lastCart.items) renderCart(lastCart);
        });
    }

    // Idle-Warten mit ehrlichem Timeout-Signal: callback(false)
    // heißt "nie idle geworden" — Composite-Ops MÜSSEN dann abbrechen,
    // sonst führen sie einen Plan auf veraltetem Cart-Stand aus.
    function waitCartIdle(callback, maxWaitMs) {
      var started = Date.now();

      (function poll() {
        if (pendingOps === 0) {
          callback(true);
          return;
        }
        if (Date.now() - started > maxWaitMs) {
          callback(false);
          return;
        }
        setTimeout(poll, 60);
      })();
    }

    function findLineByKey(cart, key) {
      var found = null;
      if (!cart || !cart.items || !key) return null;
      cart.items.forEach(function (item) {
        if (!found && item.key === key) found = item;
      });
      return found;
    }

    function buildLocalItem(variant, qty, props) {
      var unit = parseInt(variant.price, 10);
      var item = {
        key: 'pending:' + variant.id + ':' + (++localKeySeq),
        variant_id: variant.id,
        id: variant.id,
        quantity: qty,
        final_price: isBadNumber(unit) ? 0 : unit,
        price: isBadNumber(unit) ? 0 : unit,
        properties: props && Object.keys(props).length ? props : null,
        options_with_values: [],
        image: ''
      };

      if (colorPos > 0) item.options_with_values.push({ name: 'Color', value: variantOption(variant, colorPos) });
      if (sizePos > 0) item.options_with_values.push({ name: 'Size', value: variantOption(variant, sizePos) });
      item.final_line_price = item.final_price * qty;
      item.line_price = item.final_line_price;
      return item;
    }

    function changeLine(lineOrKey, quantity) {
      var payload = typeof lineOrKey === 'string'
        ? { id: lineOrKey, quantity: quantity }
        : { line: lineOrKey, quantity: quantity };
      return fetchWithTimeout('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(responseJson)
        .catch(function (error) {
          throw error;
        });
    }

    function addVariant(id, quantity, properties) {
      var payload = { id: id, quantity: quantity };
      var hasProps = false;

      properties = properties || {};
      Object.keys(properties).forEach(function (key) {
        if (properties[key]) hasProps = true;
      });
      if (hasProps) payload.properties = properties;

      return fetchWithTimeout('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(responseJson)
        .catch(function (error) {
          throw error;
        });
    }

    function rememberCartOpener(opener) {
      var active;

      if (opener && typeof opener.focus === 'function') {
        cartOpener = opener;
        return;
      }
      active = document.activeElement;
      if (active && typeof active.focus === 'function') {
        cartOpener = active;
      }
    }

    function openCart(opener) {
      if (!cartDrawer || !cartOverlay) return;
      clearTimeout(cartHideTimer);
      rememberCartOpener(opener);
      cartOverlay.classList.remove('fade-out');
      cartOverlay.hidden = false;
      void cartOverlay.offsetWidth;
      cartDrawer.classList.add('open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (cartClose && typeof cartClose.focus === 'function') cartClose.focus({ preventScroll: true });
    }

    function closeCart() {
      var hideOverlay;

      if (!cartDrawer || !cartOverlay) return;
      cartDrawer.classList.remove('open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      cartOverlay.classList.add('fade-out');
      hideOverlay = function () {
        if (cartDrawer.classList.contains('open')) return;
        cartOverlay.hidden = true;
      };
      cartOverlay.addEventListener('transitionend', hideOverlay, { once: true });
      cartHideTimer = setTimeout(hideOverlay, 300);
      document.body.style.overflow = '';
      if (cartOpener && document.body.contains(cartOpener) && typeof cartOpener.focus === 'function') {
        cartOpener.focus();
      }
    }

    function flushLineSync(key) {
      var target;

      if (qtyTimers[key] === undefined) return;
      clearTimeout(qtyTimers[key]);
      target = qtyTargets[key];
      delete qtyTimers[key];
      delete qtyTargets[key];
      if (qtyPending[key]) {
        delete qtyPending[key];
        pendingOps = Math.max(0, pendingOps - 1);
      }
      queueOp(function () {
        return changeLine(key, target);
      });
    }

    // Vor Add/Upsell alle wartenden Mengen-Syncs abschicken: der Server muss
    // die Klick-Reihenfolge sehen (erst Set, dann Increment), sonst stampft
    // der absolute Set des Debounce ein nachfolgendes Add wieder platt.
    function flushAllLineSyncs() {
      Object.keys(qtyTimers).forEach(flushLineSync);
    }

    function scheduleLineSync(key, qty, delayMs) {
      qtyTargets[key] = qty;
      if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
      if (!qtyPending[key]) {
        qtyPending[key] = true;
        pendingOps += 1;
      }
      qtyTimers[key] = setTimeout(function () {
        flushLineSync(key);
      }, delayMs);
    }

    function changeQty(key, delta) {
      var local;
      var item = null;
      var newQty;

      if (!key || key.indexOf('pending:') === 0) return;
      if (!lastCart || !lastCart.items) {
        reloadCart();
        return;
      }
      local = localCartCopy();
      local.items.forEach(function (it) {
        if (it.key === key) item = it;
      });
      if (!item) {
        reloadCart();
        return;
      }

      if (delta === 0) {
        newQty = 0;
        local.items = local.items.filter(function (it) { return it.key !== key; });
      } else if (delta > 0) {
        // UI-Cap 9: nie über 9 erhöhen — aber einen '+'-Klick NIEMALS in
        // eine Reduktion verwandeln (qty>9 ist über wiederholtes Add möglich,
        // der alte Clamp machte aus 10+1 eine 9).
        if (item.quantity >= 9) return;
        newQty = item.quantity + 1;
        item.quantity = newQty;
      } else {
        newQty = item.quantity - 1;
        if (newQty < 1) newQty = 1;
        if (newQty === item.quantity) return;
        item.quantity = newQty;
      }

      // Sofort rendern; Server-Sync gebündelt (rasche +/- Klicks = EIN Call).
      renderCart(recomputeCart(local));
      scheduleLineSync(key, newQty, delta === 0 ? 0 : 350);
    }

    function doUpsell(line, index, button) {
      var color = button ? button.getAttribute('data-color') : '';
      var size = button ? button.getAttribute('data-size') : '';
      var key = button ? button.getAttribute('data-key') : '';
      var chosen = button ? button.getAttribute('data-color2') : '';
      var target = find2PackVariant(color, size);
      var pair2Pick = chosen || firstAllowedPair2(color, size) || '';
      var props = { 'Pair 2 color': pair2Pick };
      var item;
      var newSoloQty;
      var local;

      if (isBadNumber(index)) return;
      if (!target) return;
      if (!key) return;
      // Bestands-Gate: ohne lieferbare Zweitfarbe kein Upsell
      if (!pair2Pick || !pair2Allowed(color, pair2Pick, size)) return;
      if (compositeBusy) return;
      compositeBusy = true;
      flushAllLineSyncs();

      // Optimistische Vorschau aus dem letzten bekannten Stand. Die
      // VERBINDLICHE Ausführung plant unten in der serialisierten Op auf
      // einem frisch geladenen Server-Cart — stale Keys/Mengen aus dem DOM
      // können so nie falsche Requests erzeugen.
      item = findLineByKey(lastCart, key);
      if (item && !isPackItem(item) && key.indexOf('pending:') !== 0) {
        newSoloQty = item.quantity - 1;
        local = localCartCopy();
        if (newSoloQty > 0) {
          local.items.forEach(function (it) {
            if (it.key === key) it.quantity = newSoloQty;
          });
        } else {
          local.items = local.items.filter(function (it) { return it.key !== key; });
        }
        local.items.push(buildLocalItem(target, 1, props));
        renderCart(recomputeCart(local));
      }

      // Server: frischen Cart laden, Zeile darin wiederfinden (per Key,
      // sonst per Farbe+Größe), erst adden, dann reduzieren — schlägt der
      // zweite Schritt fehl, hat der Kunde beide Zeilen statt gar keine.
      queueOp(function () {
        return fetchWithTimeout('/cart.js', { credentials: 'same-origin' })
          .then(responseJson)
          .then(function (freshCart) {
            var freshItem = findLineByKey(freshCart, key);
            var cand;
            var copts;
            var i;

            if (!freshItem) {
              for (i = 0; i < (freshCart.items || []).length; i += 1) {
                cand = freshCart.items[i];
                copts = itemOptions(cand);
                if (!isPackItem(cand) && copts.color === color && copts.size === size) {
                  freshItem = cand;
                  break;
                }
              }
            }
            if (!freshItem || isPackItem(freshItem)) return freshCart;
            return addVariant(target.id, 1, props).then(function () {
              return changeLine(freshItem.key, freshItem.quantity - 1);
            });
          })
          .then(function (cart) {
            compositeBusy = false;
            return cart;
          }, function (error) {
            compositeBusy = false;
            throw error;
          });
      });
    }

    // Merge-Klick: optimistische Vorschau aus lastCart, verbindlicher Plan
    // aus einem FRISCH geladenen Server-Cart in der serialisierten Op.
    // compositeBusy verhindert Doppelklick (zwei gültige Pläne nacheinander
    // würden zwei Packs bauen).
    function doMerge(size) {
      var plan;
      var props;
      var local;

      if (compositeBusy) return;
      compositeBusy = true;
      flushAllLineSyncs();

      function decUnit(items, key, n) {
        var kept = [];
        items.forEach(function (it) {
          if (it.key === key) {
            it.quantity -= n;
            if (it.quantity <= 0) return;
          }
          kept.push(it);
        });
        return kept;
      }

      plan = buildMergePlans(lastCart || {})[size];
      if (plan && plan.key1.indexOf('pending:') !== 0 && plan.key2.indexOf('pending:') !== 0 && lastCart && lastCart.items) {
        props = { 'Pair 2 color': plan.color2 };
        local = localCartCopy();
        if (plan.key1 === plan.key2) {
          local.items = decUnit(local.items, plan.key1, 2);
        } else {
          local.items = decUnit(local.items, plan.key1, 1);
          local.items = decUnit(local.items, plan.key2, 1);
        }
        local.items.push(buildLocalItem(plan.target, 1, props));
        renderCart(recomputeCart(local));
      }

      // Server: Plan aus frischem Cart (echte Keys/Mengen), erst adden,
      // dann reduzieren. Kein Plan im frischen Cart = No-Op, Server-Stand
      // rendert und heilt die optimistische Vorschau.
      queueOp(function () {
        return fetchWithTimeout('/cart.js', { credentials: 'same-origin' })
          .then(responseJson)
          .then(function (freshCart) {
            var freshPlan = buildMergePlans(freshCart || {})[size];
            var freshProps;

            if (!freshPlan) return freshCart;
            freshProps = { 'Pair 2 color': freshPlan.color2 };
            return addVariant(freshPlan.target.id, 1, freshProps).then(function () {
              if (freshPlan.key1 === freshPlan.key2) {
                return changeLine(freshPlan.key1, Math.max(0, freshPlan.lineQty1 - 2));
              }
              return changeLine(freshPlan.key1, freshPlan.lineQty1 - 1).then(function () {
                return changeLine(freshPlan.key2, freshPlan.lineQty2 - 1);
              });
            });
          })
          .then(function (cart) {
            compositeBusy = false;
            return cart;
          }, function (error) {
            compositeBusy = false;
            throw error;
          });
      });
    }

    function submitAdd(missingSizeCb, opener) {
      var variant;
      var props = {};

      if (sizePos > 0 && !state.size) {
        if (missingSizeCb) missingSizeCb();
        return;
      }
      variant = findVariant();
      if (!variant || !variant.available) return;
      if (idInput) idInput.value = variant.id;
      if (isMultiPackActive() && pair2Prop && !pair2Prop.disabled && pair2Prop.value) {
        // Bestands-Gate final: kein Pack mit nicht lieferbarer Zweitfarbe —
        // sichtbar abbrechen (Shake) statt still falsch verkaufen.
        if (!pair2Allowed(state.color, pair2Prop.value, state.size)) {
          if (missingSizeCb) missingSizeCb();
          applyPair2Availability();
          return;
        }
        props['Pair 2 color'] = pair2Prop.value;
      }
      // Drawer sofort öffnen UND das Item sofort optimistisch rendern —
      // die Netz-Roundtrips laufen unsichtbar im Hintergrund.
      openCart(opener);
      (function () {
        var local = localCartCopy();
        var propVal = props['Pair 2 color'] || '';
        var merged = false;

        // Merge wie der Server: gleiche Variante + gleiche Pair-2-Property.
        local.items.forEach(function (it) {
          var itProp = (it.properties && it.properties['Pair 2 color']) || '';
          if (!merged && it.variant_id === variant.id && itProp === propVal && it.key.indexOf('pending:') !== 0) {
            it.quantity += 1;
            merged = true;
          }
        });
        if (!merged) local.items.push(buildLocalItem(variant, 1, props));
        renderCart(recomputeCart(local));

        flushAllLineSyncs();
        pendingOps += 1;
        opChain = opChain.then(function () {
          // Refresh-Fehler vom Add-Fehler TRENNEN: nach bestätigtem Add darf
          // NIE erneut gepostet werden (form.submit würde die Variante ein
          // zweites Mal in den Cart legen). Refresh-Fail → null → Recovery.
          return addVariant(variant.id, 1, props).then(function () {
            return fetchWithTimeout('/cart.js', { credentials: 'same-origin' })
              .then(responseJson)
              .catch(function () { return null; });
          });
        }).then(function (cart) {
          pendingOps = Math.max(0, pendingOps - 1);
          cartGen += 1;
          if (cart) {
            settleRender(cart);
          } else {
            recoverReload();
          }
        }, function () {
          // Nur wenn das ADD selbst scheiterte, ist der native Form-Submit
          // ein sicherer Fallback (es liegt nichts doppelt im Cart).
          pendingOps = Math.max(0, pendingOps - 1);
          closeCart();
          if (form) form.submit();
        });
      })();
    }

    function findPair1SwatchByColor(color) {
      var i;
      for (i = 0; i < pair1Swatches.length; i += 1) {
        if (pair1Swatches[i].dataset.color === color) return pair1Swatches[i];
      }
      return null;
    }

    pair1Swatches.forEach(function (swatch) {
      var color = swatch.dataset.color;
      if (colorCycle.indexOf(color) === -1) colorCycle.push(color);
    });

    readImagesFromThumbs();

    if (pair1Swatches.length) {
      pair1Swatches.forEach(function (swatch) {
        if (!state.color && swatch.classList.contains('active')) state.color = swatch.dataset.color;
      });
      if (!state.color) {
        state.color = pair1Swatches[0].dataset.color;
        pair1Swatches[0].classList.add('active');
      }
      displayedColor = state.color;
      if (selectedColorText) selectedColorText.textContent = state.color;
    }

    if (bundleCards.length) {
      bundleCards.forEach(function (card) {
        if (!state.pack && card.classList.contains('active')) state.pack = card.dataset.pack;
      });
      if (!state.pack) {
        state.pack = bundleCards[0].dataset.pack;
        bundleCards[0].classList.add('active');
        bundleCards[0].setAttribute('aria-checked', 'true');
      }
    }

    if (sizeBtns.length) {
      (function () {
        var deepLinked = /[?&]variant=/.test(window.location.search);
        var activeSize = null;
        sizeBtns.forEach(function (button) {
          if (!activeSize && button.classList.contains('active')) activeSize = button;
        });
        if (deepLinked && activeSize) {
          state.size = activeSize.dataset.size;
          if (selectedSizeText) selectedSizeText.textContent = state.size;
        } else {
          sizeBtns.forEach(function (button) {
            button.classList.remove('active');
          });
          state.size = null;
          if (selectedSizeText) selectedSizeText.textContent = 'Select a size';
        }
      }());
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        activateGalleryImage(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        activateGalleryImage(currentImageIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        activateGalleryImage(currentImageIndex + 1);
      });
    }

    if (galleryMain && zoomOverlay && zoomImage) {
      galleryMain.addEventListener('click', function (event) {
        var imgs;
        if (hasAncestorClass(event.target, galleryMain, 'gallery-nav')) return;
        imgs = imageSetForColor(displayedColor);
        zoomImage.srcset = '';
        zoomImage.src = imgs && imgs.zoom ? imgs.zoom : (mainImage ? mainImage.src : '');
        zoomOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
      if (zoomClose) zoomClose.addEventListener('click', closeZoom);
      zoomOverlay.addEventListener('click', function (event) {
        if (event.target === zoomOverlay) closeZoom();
      });
    }

    pair1Swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        pair1Swatches.forEach(function (button) {
          button.classList.remove('active');
        });
        swatch.classList.add('active');
        state.color = swatch.dataset.color;
        if (selectedColorText) selectedColorText.textContent = state.color;
        setGalleryColor(state.color);
        refreshPair2Default();
        applyPair2Availability();
        updatePair2Prop();
        updateVariant();
      });
    });

    bundleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        // Gesperrte Pack-Karte (kein zweites Paar lieferbar) nicht wählbar
        if (card.dataset.akhDisabled === '1') return;
        bundleCards.forEach(function (button) {
          var on = button === card;
          button.classList.toggle('active', on);
          button.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        state.pack = card.dataset.pack;
        applyPackCard(card);
        applyPair2Availability();
        updateVariant();
      });
    });

    pair2Swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        // Bestands-Gate: gesperrte Farbe nimmt keine Auswahl an
        if (swatch.dataset.akhDisabled === '1') return;
        pair2Touched = true;
        applyPair2Color(swatch.dataset.color2);
        updatePair2Prop();
        setGalleryColor(swatch.dataset.color2);
      });
    });

    sizeBtns.forEach(function (button) {
      button.addEventListener('click', function () {
        sizeBtns.forEach(function (btn) {
          btn.classList.remove('active');
        });
        button.classList.add('active');
        state.size = button.dataset.size;
        if (selectedSizeText) selectedSizeText.textContent = state.size;
        if (sizeError) sizeError.hidden = true;
        // Größe entscheidet über Pair-2-Verfügbarkeit → Gate + Default neu
        refreshPair2Default();
        applyPair2Availability();
        updatePair2Prop();
        syncStickyBtnText();
        updateVariant();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitAdd(showMissingSizeFromForm, addToCart);
      });
    }

    tabBtns.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(button.dataset.tab);
      });
    });

    toArray(root.querySelectorAll('.faq-question')).forEach(function (question) {
      question.addEventListener('click', function () {
        var answer = question.nextElementSibling;
        var isOpen = question.getAttribute('aria-expanded') === 'true';
        question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (answer) answer.classList.toggle('open', !isOpen);
      });
    });

    if (openSizeGuide) {
      openSizeGuide.addEventListener('click', function (event) {
        event.preventDefault();
        activateTab('size');
        if (tabsSection) tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (sizeGuideModal) {
      if (modalClose) modalClose.addEventListener('click', closeSizeGuideModal);
      sizeGuideModal.addEventListener('click', function (event) {
        if (event.target === sizeGuideModal) closeSizeGuideModal();
      });
    }

    if (policyModal) {
      if (policyClose) policyClose.addEventListener('click', closePolicyModal);
      policyModal.addEventListener('click', function (event) {
        if (event.target === policyModal) closePolicyModal();
      });
      // Footer-Links (leben außerhalb dieser Section) + jeder #policy-Link
      if (!window.__akhPolicyBound) {
        window.__akhPolicyBound = true;
        document.addEventListener('click', function (event) {
          var link = event.target && event.target.closest ? event.target.closest('a[href*="#policy"]') : null;
          var hashIndex;
          if (!link) return;
          hashIndex = link.href.indexOf('#');
          if (hashIndex === -1) return;
          event.preventDefault();
          openPolicyModal(link.href.slice(hashIndex));
        });
        window.addEventListener('hashchange', function () {
          if (isPolicyHash(window.location.hash)) openPolicyModal(window.location.hash);
        });
      }
      // Deep-Link direkt beim Laden: akhletics.ae/#policy(-abschnitt)
      if (isPolicyHash(window.location.hash)) {
        openPolicyModal(window.location.hash);
      }
    }

    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartContinue) cartContinue.addEventListener('click', closeCart);
    if (cartOverlay) {
      cartOverlay.addEventListener('click', function (event) {
        if (event.target === cartOverlay) closeCart();
      });
    }
    if (cartCheckout) {
      cartCheckout.addEventListener('click', function () {
        // Laufende Hintergrund-Syncs erst landen lassen, sonst fehlt die
        // letzte Mengenänderung im Checkout. Nach Timeout NICHT blind
        // navigieren (Drawer wäre nicht Server-Wahrheit): neu syncen und
        // den Kunden erneut klicken lassen.
        waitCartIdle(function (idle) {
          if (idle && !cartSyncFailed) {
            window.location.href = '/checkout';
            return;
          }
          cartNoticeText = 'Your cart is still updating — please try again in a moment.';
          recoverReload();
        }, 4000);
      });
    }
    if (cartItems) {
      cartItems.addEventListener('click', function (event) {
        var button = event.target && event.target.closest ? event.target.closest('button') : null;
        var line;
        var delta;
        var index;
        var picker;

        if (!button || !cartItems.contains(button)) return;
        if (button.classList.contains('akh-cart-merge-btn')) {
          doMerge(button.getAttribute('data-size'));
          return;
        }
        line = parseInt(button.getAttribute('data-line'), 10);
        if (isBadNumber(line)) return;
        if (button.classList.contains('akh-cart-upsell-btn')) {
          index = parseInt(button.getAttribute('data-index'), 10);
          if (isBadNumber(index)) return;
          // Erst Farbwahl fürs zweite Paar zeigen; ohne Picker (keine
          // Swatches im DOM) direkt mit der nächsten Farbe umwandeln.
          picker = button.nextElementSibling;
          if (picker && picker.classList && picker.classList.contains('akh-cart-upsell-pick')) {
            picker.hidden = !picker.hidden;
            return;
          }
          doUpsell(line, index, button);
          return;
        }
        if (button.classList.contains('akh-cart-pick-swatch')) {
          index = parseInt(button.getAttribute('data-index'), 10);
          if (isBadNumber(index)) return;
          doUpsell(line, index, button);
          return;
        }
        if (button.classList.contains('akh-cart-qty-btn')) {
          delta = parseInt(button.getAttribute('data-delta'), 10);
          if (isBadNumber(delta)) return;
          changeQty(button.getAttribute('data-key'), delta);
          return;
        }
        if (button.classList.contains('akh-cart-item-remove')) {
          changeQty(button.getAttribute('data-key'), 0);
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (zoomOverlay && zoomOverlay.classList.contains('active')) closeZoom();
      if (sizeGuideModal && sizeGuideModal.classList.contains('active')) closeSizeGuideModal();
      if (policyModal && policyModal.classList.contains('active')) closePolicyModal();
      if (cartDrawer && cartDrawer.classList.contains('open')) closeCart();
    });

    if (stickyBuyBtn) {
      stickyBuyBtn.addEventListener('click', function () {
        if (!isSizeSelected()) {
          showMissingSizeFromSticky();
          return;
        }
        submitAdd(showMissingSizeFromSticky, stickyBuyBtn);
      });
    }

    if (stickyCart && addToCart) {
      window.addEventListener('scroll', queueStickyReveal, { passive: true });
      window.addEventListener('resize', queueStickyReveal, { passive: true });
      updateStickyReveal();
    }

    if (bandCta) {
      bandCta.addEventListener('click', scrollToBuyBox);
    }

    bandCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var swatch = findPair1SwatchByColor(card.dataset.bandcolor);
        if (swatch) swatch.click();
        scrollToBuyBox();
      });
    });

    applyPackCard(bundleCards.length ? root.querySelector('.bundle-card.active') : null);
    applyPair2Availability();
    updatePair2Prop();
    updateVariant();
    window.__akhOpenCart = function (opener) {
      // Sofort öffnen — der Boot-Load hat den Cart schon; frischer Stand
      // kommt im Hintergrund nach statt den Klick zu blockieren.
      openCart(opener);
      if (pendingOps === 0) reloadCart();
    };
    if (!window.__akhCartHeaderBound) {
      window.__akhCartHeaderBound = true;
      document.addEventListener('click', function (event) {
        var link = event.target && event.target.closest ? event.target.closest('#cart-icon-bubble, a[href="/cart"], .akh-cart-btn') : null;
        if (!link) return;
        if (!window.__akhOpenCart) return;
        event.preventDefault();
        window.__akhOpenCart(link);
      });
    }
    reloadCart().catch(function () {
      return null;
    });
  }

  function initAllRoots() {
    var roots = document.getElementsByClassName('akh-pdp');
    var i;
    for (i = 0; i < roots.length; i += 1) {
      initRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllRoots);
  } else {
    initAllRoots();
  }

  document.addEventListener('shopify:section:load', function(e){ var r = e.target.classList && e.target.classList.contains('akh-pdp') ? e.target : e.target.querySelector('.akh-pdp'); if (r) initRoot(r); });
}());
